import axios from "axios";
import { ENV } from "../config/config";
import { toast } from "react-toastify";

let baseUrl = ENV.serverUrl;

const apiHelper = async (apiType, path, data, options = {}) => {
  if (baseUrl === undefined || !baseUrl) {
    baseUrl = "";
  }

  let adminToken = localStorage.getItem("adminToken");

  if (
    apiType === "post" ||
    apiType === "put" ||
    apiType === "get" ||
    apiType === "delete"
  ) {
    try {
      let response = await axios({
        method: apiType,
        url: `${baseUrl + path}`,
        data,
        responseType: options.responseType || "json",
        headers: {
          Authorization: "Bearer " + JSON.parse(adminToken),
        },
      });
      return response;
    } catch (error) {
      // Handle blob error responses (only for SOAP note API)
      if (options.responseType === "blob" && error?.response?.data) {
        // Check if error response is a Blob
        const isBlob = error.response.data instanceof Blob || 
                      (typeof error.response.data === 'object' && error.response.data.constructor?.name === 'Blob');
        
        if (isBlob) {
          try {
            const errorText = await error.response.data.text();
            const errorJson = JSON.parse(errorText);
            if (errorJson?.message) {
              if (errorJson.message === "jwt expired") {
                ENV.logOut();
                toast.error("Session has been expired", {
                  toastId: "005",
                });
                window.location.href = "/management";
                return;
              }
              if (errorJson.message === "jwt malformed") {
                toast.error("Admin sucessfully logout", {
                  toastId: "005",
                });
                return;
              }
              toast.error(errorJson.message, {
                toastId: "005",
              });
              return;
            }
          } catch (parseError) {
            // If blob is not JSON, show generic error
            toast.error("An error occurred while downloading the file", {
              toastId: "005",
            });
            return;
          }
        }
      }

      // Standard error handling for JSON responses (all other APIs)
      if (error?.response?.data?.message) {
        if(error?.response?.data?.message=="jwt expired")
        {
          ENV.logOut()
          toast.error("Session has been expired", {
            toastId: "005",
          });
          window.location.href = "/management";
          return
        }
        if(error?.response?.data?.message=="jwt malformed")
        {
          toast.error("Admin sucessfully logout", {
            toastId: "005",
          });
          return
        }

        toast.error(error?.response?.data?.message, {
          toastId: "005",
        });
        return;
      } else {
        toast.error(error?.message, {
          toastId: "005",
        });
      }
    }
  }
};
const PromiseHandler = async (method) => {
  try {
    return await method;
  } catch (error) {
    console.log(error);
  }
};
export { PromiseHandler, apiHelper };
